import TeamManagementListSkeleton from './TeamManagementListSkeleton';

export default TeamManagementListSkeleton;
